import { render, staticRenderFns } from "./RmpMessageBox.vue?vue&type=template&id=6fe4b559&scoped=true"
import script from "./RmpMessageBox.vue?vue&type=script&lang=js"
export * from "./RmpMessageBox.vue?vue&type=script&lang=js"
import style0 from "./RmpMessageBox.vue?vue&type=style&index=0&id=6fe4b559&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe4b559",
  null
  
)

export default component.exports